// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"articles_wrapper__Ug6Vd","header":"articles_header__oTDyD","show_case_articles":"articles_show_case_articles__puIF7"};